"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

require("./notification.scss");

var info = "info";

var noop = function noop() {};

var InlineNotification = function InlineNotification(_ref) {
  var _ref$dismissable = _ref.dismissable,
      dismissable = _ref$dismissable === void 0 ? false : _ref$dismissable,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? info : _ref$type,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? noop : _ref$onClose,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "nstyle-inline-notification ".concat(getClassNameForType(type))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "nstyle-inline-notification--icon"
  }, getIconForType(type)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "nstyle-inline-notification--content"
  }, children), dismissable && /*#__PURE__*/_react["default"].createElement("div", {
    className: "nstyle-inline-notification--dismiss"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: "".concat(cdnBasePath, "/icons/x-grey.svg"),
    onClick: onClose
  })));
};

var cdnBasePath = "https://ncontracts-cdn.ncontracts.com/1.0.225";

var getClassNameForType = function getClassNameForType(type) {
  return "nstyle-inline-notification--".concat(type);
};

var getIconForType = function getIconForType(type) {
  var titled = "".concat(type.substring(0, 1).toUpperCase()).concat(type.substring(1));
  var source = "".concat(cdnBasePath, "/icons/").concat(titled, "-Notification-Icon.svg");
  return /*#__PURE__*/_react["default"].createElement("img", {
    src: source
  });
};

var _default = InlineNotification;
exports["default"] = _default;